import React, {Component} from 'react'
import ReactTable from "react-table";
import { Redirect } from 'react-router-dom'
import * as config from '../Configuration/Config.js'
import UserProfile from '../Configuration/UserProfile.js'

class AdminSecurityRoleGrid extends Component {
    constructor() {
        super();

        this.handleNew = this.handleNew.bind(this)
        this.handleBack = this.handleBack.bind(this)

        this.state = {
            is_loaded: false,
            redirect_new: false,
            redirect_back: false,
            customer_id: 0,
            roles: []
        }
    }

    setRedirectNew() {
        this.setState({redirect_new: true});
    }

    setRedirectBack() {
        this.setState({redirect_back: true});
    }

    componentDidMount() {
        // const user_id = this.props.match.params.uid;
        const customer_id = this.props.match.params.cid;

        if (!customer_id) {
            this.setState({ is_loaded: true, id: null, user: null, customer_id: 0 });
            return;
        }

        var that = this;
        const uri = config.getUriPath('securityroles/all/' + customer_id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
          })
          .then(function(data) {
            that.setState({ is_loaded: true, customer_id: customer_id, roles: data });
            //that.fetchDashboardsList(customer_id, data);
        });
    }

    handleNew(event) {
        event.preventDefault();

        this.setRedirectNew();
    }

    handleBack(event) {
        event.preventDefault();

        this.setRedirectBack();        
    }

    render() {
        if (this.state.is_loaded === false) {
            return <div></div>
        }

        const customer_id = this.state.customer_id;
        if (customer_id === 0){
            return <div>No customer provided</div>
        }

        if (this.state.redirect_new){
            return <Redirect to={'/admin/security/roles/' + customer_id + '/new'} />
        }

        const profile = new UserProfile();
        const isAcumenAdmin = profile.IsAcumenAdmin();

        if (isAcumenAdmin && this.state.redirect_back){
            return <Redirect to='/admin/customers' />
        }

        const roles = this.state.roles;
        return <div className="grid-wrapper">
                    <div className="center-div">
                        <h1>Security Roles</h1>
                    </div>
                    <div className="addNewButton">
                        <button className="btn btn-primary" onClick={this.handleNew}>Add New Security Role</button>
                        {/* &nbsp;&nbsp;
                        <button className={isAcumenAdmin ? "btn btn-primary" : "hidden"} onClick={this.handleBack}>Back to Customer</button> */}
                    </div>
                    <div className="ReactTableCenter center-div">
                        <ReactTable
                            data={roles}
                            minRows="0"
                            columns={[
                                {
                                    accessor: "id",
                                    width: 100,
                                    resizable: false,
                                    Header: "Edit",
                                    style: { textAlign: "center"},
                                    Cell: row=>(
                                        <a href={'/admin/security/roles/' + customer_id + '/' + row.value}><i className="fas fa-edit"></i></a>
                                    )
                                },
                                {
                                    Header: "Role Name",
                                    accessor: "role_name"
                                }
                            ]}
                            defaultPageSize={15}
                            className="-striped -highlight"
                        >
                        </ReactTable>
                    </div>
            </div>
    }
}

export default AdminSecurityRoleGrid


// WEBPACK FOOTER //
// ./src/Components/AdminSecurityRoles/AdminSecurityRolesGrid.js